<template>
  <div class="pb-10">
    <v-row>
      <v-col cols="12" md="9" class="flex-md-grow-1 pr-md-10" order="2" order-md="1">
        <slot name="step-content" ></slot>
      </v-col>
      <v-col cols="12" md="3" order="1" order-md="2">
        <v-card color="#E7EFFD" class="py-10 pl-5 pr-8 black--text d-none d-md-block" flat>
          <div class="d-flex align-center">
            <div class="mr-5">
              <v-icon x-large>
                mdi-phone
              </v-icon>
            </div>
            <div>
              <div class="text-h6">
                Ai intrebari?
              </div>
              <div class="text-subtitle-1">
                Contacteaza-ne
              </div>
              <div class="font-weight-bold">
                060/50 - 29 - 01
              </div>
            </div>
          </div>
        </v-card>
        <v-card color="#df0100" class="pa-2 pa-md-8 white--text mt-md-4" flat>
          <div class="d-flex flex-column align-center">
            <div class="text-h6 mb-2">
              Comanda
            </div>
            <div v-if="orderTotal > 0" class="font-weight-bold">
              {{ orderTotal }} LEI
            </div>
            <div v-else>-</div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'StepWithSidebar',
  props: {
    orderTotal: [String, Number]
  }
};
</script>

<style scoped>

</style>